/**
 * FORGE — entry shell.
 *
 * There is ONE FORGE surface: the cockpit at `/forge`, with the selected tender
 * in `?tender=<id>`. It carries the tender list, the Operator Agent, the Accio
 * pane, and the spec/sourcing/quotes/validation panels as docked facets.
 *
 * `/forge/:id` used to render a second, tabbed workspace shell wrapping the same
 * panels. Nothing in the app ever linked to it — every entry point (SavedTenderCard,
 * MyTenders, TenderDetailAugmented) navigates to `/forge?tender=<id>` — so it was
 * reachable only by typing the URL, while presenting itself in code as the "full"
 * view. Two shells over one set of panels is what made FORGE feel like two
 * different products. The shell is gone; the path now redirects so any bookmark
 * or pasted link still lands somewhere real.
 */
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ForgeCockpit from './cockpit/ForgeCockpit';
import './Forge.css';

const Forge = () => {
  const { id } = useParams();
  const tenderId = id ? decodeURIComponent(id) : null;

  if (tenderId) {
    return <Navigate to={`/forge?tender=${encodeURIComponent(tenderId)}`} replace />;
  }

  return <ForgeCockpit />;
};

export default Forge;
